import axios from "axios";

const Instance = axios.create({
  baseURL: "https://eqcas-backend-eske.onrender.com/api/v1/",
  // baseURL:"http://localhost:5000/api/v1"
});

// ✅ Add Authorization header for every request
Instance.interceptors.request.use(
  (config) => {
    
   const token = JSON.parse(localStorage.getItem("userData"))?.token;
// get token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default Instance;
